
/**
 * @description
 * 홈 > 재능 > 흥미를 찾아주는 특별한 선생님
 */

import { mapActions } from 'vuex';

import TeacherCuration from '../../common/teacher/TeacherCuration.vue';

export default {
  name: 'Teacher',
  components: { TeacherCuration },
  data() {
    return {
      bestTeacherList: [],
    };
  },
  fetchOnServer: false,
  async fetch() {
    try {
      this.bestTeacherList = await this.getBestTeacherList({ isTalent: true });
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    ...mapActions('new-home', ['getBestTeacherList']),
  },
};
